import { configureSync, getConfig, getConsoleSink } from '@logtape/logtape';

export function ensureClientLogging() {
  if (getConfig()) {
    return;
  }

  configureSync({
    sinks: {
      console: getConsoleSink(),
    },
    loggers: [
      {
        category: ['scoville-meet'],
        lowestLevel: process.env.NODE_ENV === 'production' ? 'info' : 'debug',
        sinks: ['console'],
      },
      {
        category: ['logtape', 'meta'],
        lowestLevel: 'warning',
        sinks: ['console'],
      },
    ],
  });
}

if (typeof window !== 'undefined') {
  ensureClientLogging();
}
